<template>
    <v-row v-if="isUserEmployee || isUserEmployer" align="baseline" class="row--x-small">
        <v-col cols="auto">
            <v-icon size="8" :color="color_icon">mdi-circle</v-icon>
        </v-col>
        <v-col class="page-text--sm" style="color: #111"> {{ text }} </v-col>
    </v-row>
</template>

<script>
import { initExpoMatching } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initExpoMatching },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },

    computed: {
        color_icon() {
            switch (this.value.isGranted) {
                case null: {
                    return "primary";
                }
                case true: {
                    return "secondary";
                }
                case false: {
                    return "grey-5f";
                }
            }
        },
        text() {
            switch (this.value.isGranted) {
                case null: {
                    return "매칭 진행중";
                }
                case true: {
                    return "매칭완료";
                }
                case false: {
                    return "매칭실패";
                }
            }
        },
    },
};
</script>

<style>
</style>